import React from "react";
import { withRouter } from "react-router";
import { Table, Tag } from "antd";
import { showColumnAction } from "./AudienceColumn";
import "./AudienceTable.css";

function AudienceTable(props) {
  const { dataList, setVisible, setUserData, deleteData, onMembersClick } = props;

  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: "Audience Name",
      dataIndex: "name",
      fixed: "left",
      width: 200,
      sorter: (a, b) => `${a.name}`.localeCompare(`${b.name}`),
    },
    {
      title: "Audience Type",
      dataIndex: "channel",
      width: 120,
      render: (channel) => {
        const isSms = (channel || "email") === "sms";
        return <Tag color={isSms ? "blue" : "green"}>{isSms ? "SMS" : "Email"}</Tag>;
      },
    },
    {
      title: "# Members",
      dataIndex: "member_count",
      width: 120,
      align: "center",
      sorter: (a, b) => a.member_count - b.member_count,
      render: (count, record) => (
        <span
          style={{ color: "var(--mainColor)", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => onMembersClick(record)}
        >
          {count ?? 0}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "created_date",
      width: 150,
      render: (info) => {
        if (info !== undefined && info != null && info != "") {
          let year = info.split("-")[0];
          let month = info.split("-")[1];
          let day = info.split("-")[2];
          return month + "/" + day + "/" + year.substr(-2);
        }
        return info;
      },
      sorter: (a, b) => `${a.created_date}`.localeCompare(`${b.created_date}`),
    },
    {
      title: "Action",
      dataIndex: "operator",
      width: 220,
      fixed: "right",
      render: (op, info) =>
        showColumnAction(info, setVisible, setUserData, deleteData, onMembersClick),
    },
  ];

  const dataSource =
    dataList.length === 0
      ? []
      : dataList.map((data, index) => ({ ...data, key: index }));

  return (
    <div className="info-list-widget">
      <Table
        columns={columns}
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        scroll={{ x: 700 }}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
}

export default withRouter(AudienceTable);
